"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var rich_text_viewer_1 = require("@csod/rich-text-viewer");
var RichTextViewer = (function (_super) {
    __extends(RichTextViewer, _super);
    function RichTextViewer(props) {
        return _super.call(this, props) || this;
    }
    RichTextViewer.prototype.render = function () {
        return React.createElement(rich_text_viewer_1.default, __assign({}, this.props));
    };
    return RichTextViewer;
}(React.Component));
exports.RichTextViewer = RichTextViewer;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["RichTextViewer"] = [];


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/RichTextViewer/RichTextViewer.js
// module id = 122
// module chunks = 0